var DataProcessor = require("./data_processor");
module.exports = {
	DEPRECATED_api: function(server) {
		return new (DataProcessor.DataProcessor)(server);
	},
	createDataProcessor: DataProcessor.createDataProcessor,
	getDataProcessorModes: DataProcessor.getAvailableModes
};